/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './health-camp.reducer';

export const HealthCampDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const healthCampEntity = useAppSelector(state => state.healthCamp.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="healthCampDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.healthCamp.detail.title">HealthCamp</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.healthCamp.id">Id</Translate>
            </span>
          </dt>
          <dd>{healthCampEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.healthCamp.name">Name</Translate>
            </span>
          </dt>
          <dd>{healthCampEntity.name}</dd>
          <dt>
            <span id="code">
              <Translate contentKey="tinyMedicRestApp.healthCamp.code">Code</Translate>
            </span>
          </dt>
          <dd>{healthCampEntity.code}</dd>
          <dt>
            <span id="sponsoredBy">
              <Translate contentKey="tinyMedicRestApp.healthCamp.sponsoredBy">Sponsored By</Translate>
            </span>
          </dt>
          <dd>{healthCampEntity.sponsoredBy}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="tinyMedicRestApp.healthCamp.description">Description</Translate>
            </span>
          </dt>
          <dd>{healthCampEntity.description}</dd>
          <dt>
            <span id="startDate">
              <Translate contentKey="tinyMedicRestApp.healthCamp.startDate">Start Date</Translate>
            </span>
          </dt>
          <dd>{healthCampEntity.startDate}</dd>
          <dt>
            <span id="endDate">
              <Translate contentKey="tinyMedicRestApp.healthCamp.endDate">End Date</Translate>
            </span>
          </dt>
          <dd>{healthCampEntity.endDate}</dd>
          <dt>
            <span id="location">
              <Translate contentKey="tinyMedicRestApp.healthCamp.location">Location</Translate>
            </span>
          </dt>
          <dd>{healthCampEntity.location}</dd>
          <dt>
            <span id="organizerType">
              <Translate contentKey="tinyMedicRestApp.healthCamp.organizerType">Organizer Type</Translate>
            </span>
          </dt>
          <dd>{healthCampEntity.organizerType}</dd>
          <dt>
            <span id="organizerId">
              <Translate contentKey="tinyMedicRestApp.healthCamp.organizerId">Organizer Id</Translate>
            </span>
          </dt>
          <dd>{healthCampEntity.organizerId}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.healthCamp.active">Active</Translate>
            </span>
          </dt>
          <dd>{healthCampEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.healthCamp.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{healthCampEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.healthCamp.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{healthCampEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.healthCamp.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{healthCampEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.healthCamp.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{healthCampEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.healthCamp.contactDetails">Contact Details</Translate>
          </dt>
          <dd>{healthCampEntity.contactDetails ? healthCampEntity.contactDetails.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.healthCamp.type">Type</Translate>
          </dt>
          <dd>{healthCampEntity.type ? healthCampEntity.type.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/health-camp" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/health-camp/${healthCampEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default HealthCampDetail;
